import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { HealthClaimSettlementComponent } from 'src/app/components/health-claim-settlement/health-claim-settlement.component';
import { ConnectionService } from 'src/app/services/connection.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-care-quote-plans',
  templateUrl: './care-quote-plans.page.html',
  styleUrls: ['./care-quote-plans.page.scss'],
})
export class CareQuotePlansPage implements OnInit {

  members: any = []
  healthQuoteList: any = [];
  crQuoteReq: any;
  topUpIns: any;
  coverAmt: any = [];
  coverAmountDetails: any = [];
  sumInsuredAmt: number;

  constructor(private router: Router, private _dataFields: DataFieldsService, private route: ActivatedRoute, private strg: StorageService, private apiService: ConnectionService,
    private modalCtrl: ModalController) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: any) => this.topUpIns = params.params.data);
  }
  ionViewDidEnter() {
    if (!this.topUpIns) {
      // this.strg.getStoreData("hlcr_quoteRes").then(res => { // commented for generic healh
      this.strg.getStoreData("hlcr_quoteReq").then(res => { //added for generic health
        // let quoteRes = JSON.parse(res) // commented for generic healh
        // console.log(quoteRes.publicUserQuoteDetails) // commented for generic healh
        // this.members = JSON.parse(quoteRes.publicUserQuoteDetails.insurer) // commented for generic healh
        // console.log(this.members) // commented for generic healh
        //console.log(JSON.parse(res));
        console.log("ererere", res)
        this.members = res.insurer
        console.log(this.members)
      })
      this.apiService.healthQuoteListArray.subscribe(quoteList => {
        // this.healthQuoteList = quoteList;
        console.log("health quote list", this.healthQuoteList);
        if (quoteList.length === 0) {
          this.router.navigate(['/care-quote-form']);
        }
        else {
          this.healthQuoteList = quoteList;
          this.strg.getStoreData("hlcr_quoteReq").then(res => {
            this.crQuoteReq = res;
            this.triggerPublicQuoteEmail();
          })
        }
      });
    }
    else if (this.topUpIns) {
      this.apiService.healthQuoteListArray.subscribe(quoteList => {
        this.healthQuoteList = quoteList;
        console.log("health quote list", this.healthQuoteList);
        this.healthQuoteList.forEach(element=>{
          console.log(element)
          if(element.insurerArray){
            this.members=element.insurerArray
          }
          else if(element.req){
            this.members=element.req
          }
        })
        console.log(this.members)
        if (quoteList.length === 0) {
          this.router.navigate(['/care-quote-form'], { queryParams: { data:'topUp' } });  
              }
        else {
          this.healthQuoteList = quoteList;
          this.strg.getStoreData("hlcr_quoteReq").then(res => {
            this.crQuoteReq = res;
            console.log(this.crQuoteReq)
            this.triggerPublicTopUpQuoteEmail();
          })
        }
      });
    }

  }
  async openConfirmModal(data) {
    console.log(data,"open confirmation")
    const modal = await this.modalCtrl.create({
      component: HealthClaimSettlementComponent,
      componentProps: {
        dataSelected: data,
        // formData: this.planUpgradeForm.value
      },
      cssClass: "modal-settlement",
      showBackdrop: false,
      backdropDismiss: false,
      swipeToClose: true
    });

    modal.onDidDismiss().then((isOkay) => {
      console.log("isOkay2Proceed", isOkay);
    });

    return await modal.present();
  }

  routeTo(data) {
    console.log('rtdata',data)
    this.strg.setStoreData("hlQuoteForUpgrade", data);
    if(!this.topUpIns){
      this.router.navigate(['./care-quote-confirmation']);
    }
    else{
      this.router.navigate(['./care-quote-confirmation'] ,{ queryParams: { data:'topUp' } });
    }
  }
  getCashlessHosp() {
    if(!this.topUpIns){
      this.router.navigate(['./care-quote-settlement'])
    }
    else{
      this.router.navigate(['./care-quote-settlement'], { queryParams: { data:'topUp' } })
    }
  }

  triggerPublicQuoteEmail() {
    setTimeout(() => {
      let reqData = {
        firstName: this.crQuoteReq.name,
        email: this.crQuoteReq.email,
        products: [],
      }
      console.log("this.quotelist", this.healthQuoteList);
      this.healthQuoteList.forEach(ele => {
        reqData.products.push({
          productName: ele.productName,
          sumAssuredAmount: ele.sumInsured + "Lac",
          policyTerm: ele.term,
          coverType: ele.coverType,
          insurerName: ele.insurerName,
          premiumAmount: String(ele.premiumAmount),
        })
      })
      console.log("products array for email trigger", reqData);
      this.apiService.healthPublicQuoteEmailTrigger(reqData).subscribe(res => {
        console.log("triggerEmail", res);
      })
    }, 1000);
  }
  triggerPublicTopUpQuoteEmail() {
    setTimeout(() => {
      let reqData = {
        firstName: this.crQuoteReq.name,
        email: this.crQuoteReq.email,
        products: [],
      }
      console.log("this.quotelist", this.healthQuoteList);
      this.healthQuoteList.forEach(ele => {
        console.log(ele)
        reqData.products.push({
          productName: ele.productName,
          sumInsured: ele.sumInsured + "Lac",
          deductible: ele.deductible + "Lac",
          policyTerm: ele.term,
          coverType: ele.coverType,
          insurer: ele.insurerName,
          premiumAmount: String(ele.premiumAmount),
        })
      })
      console.log("products array for email trigger", reqData);
      this.apiService.topUpPublicQuoteEmailTrigger(reqData).subscribe(res => {
        console.log("triggerEmail", res);
      })
    }, 1000);
  }
}
